import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { AnnouncementDTO } from "./GetAllAnnouncements";
type AddAnnouncementDTO = {
    title: string,
    message: string,
    deadline:string,
};

type AnnouncementResponse  = AnnouncementDTO & ApiError;

export const AddNewAnnouncement = (data: AddAnnouncementDTO): Promise<AnnouncementResponse> => {
    return axios.post("/announcement/create", data)
        .then(response => response.data as AnnouncementResponse);
};